module.exports = __webpack_public_path__ + "static/media/greenFree1.dc7111da.jpg";